// Tailwind was not consistently respecting cascading values with text classes enough to the point where it was worth creating this utility.
const textClassSwitcher = (className: string, defaultTextClass: string) => {
  if (className?.includes('text-')) {
    return className;
  }

  return defaultTextClass;
};

export default textClassSwitcher;
